import { Slide, TextAlignment } from '@/client/courses/types/courses.type';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import styled from 'styled-components';

const SlideTitle = styled(ReactQuill)`
  .ql-editor p {
    font-weight: 700;
    font-size: 30px;
  }

  min-width: 100px;
  margin: 0;
  padding: 0;
`;

type RichTextTitleProps = {
  currentEditingSlide: Slide;
  isEditingPopUpSlide: boolean;
  currentSlideData: Slide;
  updateSlide: (id: string, updates: Partial<Slide>) => void;
  isPurpleBackground?: boolean;
};

export const RichTextTitle: React.FC<RichTextTitleProps> = ({
  currentEditingSlide,
  isEditingPopUpSlide,
  currentSlideData,
  updateSlide,
  isPurpleBackground,
}) => {
  const { t } = useTranslation();

  return (
    <SlideTitle
      key={`title-editor-${isEditingPopUpSlide ? 'popup' : 'main'}`}
      value={currentEditingSlide?.headline || ''}
      theme="snow"
      className={`quill-editor quill-editor-v2 title ${
        currentSlideData.textAlignment === TextAlignment.CENTER
          ? 'text-center'
          : 'text-left'
      } ${isPurpleBackground ? 'quill-editor-summary' : ''}`}
      placeholder={
        isEditingPopUpSlide
          ? t('content.popup.slide.title')
          : t('content.slide.title')
      }
      modules={{
        toolbar: false,
        clipboard: {
          matchVisual: false,
        },
      }}
      onChange={(html, delta, source, editor) => {
        if (!currentEditingSlide?.id || source !== 'user') return;

        const textContent = editor.getText().trim();
        updateSlide(currentEditingSlide.id, {
          headline: textContent.length > 0 ? html : '',
        });
      }}
    />
  );
};
